import { LightAlert } from 'components/shared/LightAlert';
import { FC } from 'react';

import type { QuoteWarningState } from './quoteWarning.connect';
import { connectQuoteWarning } from './quoteWarning.connect';

export const WarningMessageComponent: FC<QuoteWarningState> = ({ warningMessages }) => {
  if (!warningMessages) {
    return null;
  }

  return warningMessages.map(warningMessage => (
    <LightAlert key={warningMessage.code} severity="warning" e2e="quote-warning">
      {warningMessage.message}
    </LightAlert>
  ));
};

export const QuoteWarning = connectQuoteWarning(WarningMessageComponent);
